import React from "react";
import MenuItem from "./MenuItem";

const MenuSection = ({ title, gridClass, items }) => {
  return (
    <div className='mb-3'>
      <p className="text-xs font-semibold dark:text-customTitleColor text-slate-500">{title}</p>
      <div className={gridClass}>
        {items.map((item) => (
          <MenuItem
            key={item.id ?? item.title}
            title={item.title}
            href={item.href}
            Icon={item.Icon}
            bgClass={item.bgClass}
            spanClass={item.spanClass}
            description = {item.description}
          />
        ))}
      </div>
    </div>
  );
};

export default MenuSection;


